import PageLayout from '@/components/PageLayout';
import Button from '@/components/UI/Button';
import Image from '@/components/UI/Image';
import Input from '@/components/UI/Input';
import { localeMapWensiSpecial } from '@/constants';
import { resetPassword } from '@/service';
import { useGlobal } from '@/utils/useGlobal';
import { Form } from 'antd';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import css from './index.module.scss';
const getLangKey = (str: string) => {
    let val = '';
    for (const key in localeMapWensiSpecial) {
        if (str === localeMapWensiSpecial[key]) {
            val = key;
        }
    }

    return val;
};

export default function ResetPassword({ lang, SEO }: any) {
    const { useState, useRouter, isMobile, useLang, useEffect } = useGlobal();
    const { t } = useLang('shared');
    const [loading, setIsLoading] = useState(false);
    const [allValidate, setAllValidate] = useState({ pwd: false, confirmPwd: false });
    const [isErrorTip, setIsErrorTip] = useState(false);
    const [errorTip, setErrorTip] = useState('');
    const [code, setCode] = useState('');
    const [email, setEmail] = useState('');
    const [inputClass, SetInputClass] = useState({
        activeFirst: '',
        activeSecond: '',
        activeThird: '',
        name: '',
    });
    const router = useRouter();
    const { locale } = router;

    // 校验密码
    const validatePassword = () => {
        return {
            validator(_: any, value: any) {
                const regx = /^.*(?=.*[0-9])(?=.*[A-Za-z])(?=^.{6,32}$).*$/;
                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ pwd: false },
                    });
                    return Promise.reject(t('logintips.site_login_tip_password_empty'));
                }
                if (!value || regx.test(value)) {
                    setAllValidate({
                        ...allValidate,
                        ...{ pwd: true },
                    });
                    return Promise.resolve();
                }

                setAllValidate({
                    ...allValidate,
                    ...{ pwd: false },
                });

                return Promise.reject(t('logintips.site_login_tip_password_format_wrong'));
            },
        };
    };

    // 校验确认密码
    const validateConfirmPassword = ({ getFieldValue }: any) => {
        return {
            validator(_: any, value: any) {
                const pwd = getFieldValue('password');

                setIsErrorTip(false);

                if (!value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ confirmPassword: false },
                    });
                    return Promise.reject(t('logintips.site_login_tip_password_confirm_empty'));
                }

                if (pwd !== value) {
                    setAllValidate({
                        ...allValidate,
                        ...{ confirmPassword: false },
                    });
                    return Promise.reject(t('logintips.site_login_tip_password_twice_inconsistent'));
                }

                setAllValidate({
                    ...allValidate,
                    ...{ confirmPassword: true },
                });
                return Promise.resolve();
            },
        };
    };

    const onFinish = async (values: any) => {
        const data = {
            code: code || '',
            email: email || '',
            password: Base64.stringify(Utf8.parse(values.password)),
            confirmPassword: Base64.stringify(Utf8.parse(values.confirmPassword)),
            verificationScene: 'WEB_RESET_PASSWORD',
        };

        try {
            setIsLoading(true);

            const res: any = await resetPassword(data);

            if (res.code === '0') {
                router.push(`/${locale}/validate/resetsuccess`);
            } else {
                setErrorTip(res.message);
                setIsErrorTip(true);
            }
            setIsLoading(false);
        } catch (err) {
            setIsLoading(false);
        }
    };

    const onBlurInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: '',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: '',
                    name: value,
                });
            }
        }
    };

    const onFocusInput = (event: any, value: any) => {
        if (!event.target.value) {
            if (value == 'pwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: 'active',
                    activeThird: inputClass.activeThird,
                    name: value,
                });
            } else if (value == 'conpwd') {
                SetInputClass({
                    activeFirst: inputClass.activeFirst,
                    activeSecond: inputClass.activeSecond,
                    activeThird: 'active',
                    name: value,
                });
            }
        }
    };

    useEffect(() => {
        // const lastPath = getLastPathName();
        // 修改为动态路由
        const { info } = router.query;
        const decodeLastPath = window.atob(info);
        // if (typeof window !== 'undefined') {
        //     decodeLastPath = window.atob(lastPath)
        // }
        const params = getUrlParams(`${router.asPath}?${decodeLastPath}`);
        const { email, code, lang } = params;

        let localStr = getLangKey(lang);

        if (!localStr) {
            localStr = 'us';
        }

        if (locale === 'en') {
            const href = window.location.href;
            const pathname = window.location.pathname;

            window.location.href = `/${localStr}${pathname}`;
        } else if (localStr !== locale) {
            let href = window.location.href;
            href = href.replace(`/${locale}/`, `/${localStr}/`);
        }

        setCode(code);
        setEmail(email);
    }, []);

    return (
        <PageLayout style={{ background: '#f8f8f8' }}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <div className={`${css.validate}`}>
                {/* {lang.title} */}
                <div className="validate-wrap login_page_a">
                    <div className="validate-box">
                        {!isMobile && (
                            <h2>
                                <Image src="/icons/logo.svg" width={140} height={15} alt={lang.site_login_forgot_password_reset_password} />
                            </h2>
                        )}

                        <p className="desc">{lang.site_login_forgot_password_reset_password}</p>
                        <Form name="normal_validate" className="validate-form" initialValues={{ remember: true }} onFinish={onFinish}>
                            <div className="inputItem">
                                <label className={inputClass.activeSecond == 'active' ? 'active' : ''}>{lang.site_login_forgot_password_new_password}</label>
                                <Form.Item name="password" shouldUpdate rules={[validatePassword]} validateTrigger="onBlur">
                                    <Input.Password
                                        type="password"
                                        className="default-input"
                                        aria-label={lang.site_login_forgot_password_new_password}
                                        iconRender={(visible: boolean) => {
                                            return (
                                                <div>
                                                    <i className={`iconfont ${visible ? 'icon-eye-in' : 'icon-eye-out'}`}></i>
                                                </div>
                                            );
                                        }}
                                        onFocus={(e: any) => onFocusInput(e, 'pwd')}
                                        onBlur={(e: any) => onBlurInput(e, 'pwd')}
                                    />
                                </Form.Item>
                            </div>
                            <div className="inputItem">
                                <label className={inputClass.activeThird == 'active' ? 'active' : ''}>{lang.site_register_enter_password_again}</label>
                                <Form.Item
                                    name="confirmPassword"
                                    shouldUpdate
                                    dependencies={['password']}
                                    rules={[validateConfirmPassword]}
                                    validateTrigger="onBlur"
                                >
                                    <Input.Password
                                        type="password"
                                        className="default-input"
                                        aria-label={lang.site_register_enter_password_again}
                                        iconRender={(visible: boolean) => {
                                            return (
                                                <div>
                                                    <i className={`iconfont ${visible ? 'icon-eye-in' : 'icon-eye-out'}`}></i>
                                                </div>
                                            );
                                        }}
                                        onFocus={(e: any) => onFocusInput(e, 'conpwd')}
                                        onBlur={(e: any) => onBlurInput(e, 'conpwd')}
                                    />
                                </Form.Item>
                                {isErrorTip && <div className="error-tip">{errorTip}</div>}
                            </div>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="black-btn large validate-form-button"
                                    loading={loading}
                                    aria-label={t('Submit')}
                                    disabled={!(allValidate.pwd && allValidate.confirmPassword)}
                                >
                                    {t('Submit')} {''}
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
}

// function getLastPathName() {
//     let url = '';
//     let index: any = '';

//     if (typeof window !== undefined) {
//         url = window.location.href;
//         index = url.lastIndexOf('/');
//     }

//     return url.substring(index + 1, url.length);
// }

function getUrlParams(url: any) {
    const _url = url;
    const _urlParams = _url.match(/([?&])(.+?=[^&]+)/gim);
    return _urlParams
        ? _urlParams.reduce((a, b) => {
              const value = b.slice(1).split('=');
              a[value[0]] = value[1];
              return a;
          }, {})
        : {};
}
